import utils from './utils'; 

import imgToSvg from './components/img-to-svg';
import lazyLoad from './components/lazy-load';

function initHiPriority() {
    imgToSvg.init();
	lazyLoad.init();
}

utils.domReady(function () {
	initHiPriority(); 
});